export const DEFAULT_CANVAS_WIDTH = 500;
export const DEFAULT_CANVAS_HEIGHT = 500;
export const DEFAULT_POSITION_X = 0;
export const DEFAULT_POSITION_Y = 0;
export const DEFAULT_IMAGE_WIDTH = 200;
export const DEFAULT_IMAGE_HEIGHT = 200;
